// extracted by mini-css-extract-plugin
export default {"pagina":"Pagina_pagina__mF4Lg"};